'use strict'

;(function () {
	const _elData = new WeakMap()

	function elData(el, key, value) {
		if (!el) return undefined
		if (value !== undefined) {
			const map = _elData.get(el) || {}
			map[key] = value
			_elData.set(el, map)
			return value
		}
		const stored = _elData.get(el)
		if (stored && stored[key] !== undefined) return stored[key]
		const camel = key.replace(/-([a-z])/g, (_, c) => c.toUpperCase())
		return el.dataset[camel]
	}

	var adpPopup = {
		sPrevious: window.scrollY,
		sDirection: 'down',

		init: function () {
			adpPopup.popupInit()
			adpPopup.events()
		},

		events: function () {
			document.addEventListener('click', function (e) {
				const closeBtn = e.target.closest('.popup-close')
				if (closeBtn) adpPopup.closePopup(closeBtn)

				const acceptBtn = e.target.closest('.popup-accept')
				if (acceptBtn) {
					adpPopup.acceptPopup(acceptBtn)
					adpPopup.closePopup(acceptBtn)
				}

				const ageCloseBtn = e.target.closest('.age-verification__popup-close')
				if (ageCloseBtn) {
					adpPopup.agePopup(ageCloseBtn)
					adpPopup.closePopup(ageCloseBtn)
				}

				if (e.target.closest('.age-verification__button-no')) {
					adpPopup.ageDeclined()
				}

				if (e.target.closest('.popup-overlay')) {
					document.querySelectorAll('.popup-open[data-overlay-close="true"]').forEach(function (popup) {
						adpPopup.closePopup(popup)
					})
				}
			})

			document.addEventListener('keyup', function (e) {
				if (e.key === 'Escape') {
					document.querySelectorAll('.popup-open[data-esc-close="true"]').forEach(function (popup) {
						adpPopup.closePopup(popup)
					})
				}
				if (e.key === 'F4') {
					document.querySelectorAll('.popup-open[data-f4-close="true"]').forEach(function (popup) {
						adpPopup.closePopup(popup)
					})
				}
			})
		},

		popupInit: function () {
			document.addEventListener('scroll', function () {
				const scrollCurrent = window.scrollY
				adpPopup.sDirection = scrollCurrent > adpPopup.sPrevious ? 'down' : 'up'
				adpPopup.sPrevious = scrollCurrent
			})

			document.querySelectorAll('.popup').forEach(function (popup) {
				if ('manual' === elData(popup, 'open-trigger')) {
					const selector = elData(popup, 'open-manual-selector')

					if (selector) {
						document.querySelectorAll(selector).forEach(function (el) {
							el.classList.add('popup-trigger')
						})

						document.addEventListener('click', function (e) {
							const trigger = e.target.closest(selector)
							if (!trigger) return

							e.preventDefault()
							popup.classList.remove('popup-already-opened')
							adpPopup.openPopup(popup)

							if (trigger.classList.contains('popup')) {
								adpPopup.closePopup(trigger)
							}
						})
					}
				}

				if (!adpPopup.isAllowPopup(popup) && !popup.classList.contains('age-verification')) {
					return
				}

				adpPopup.openTriggerPopup(popup)
			})
		},

		openTriggerPopup: function (popup) {
			const trigger = elData(popup, 'open-trigger')

			if ('none' === trigger) {
				const ageVerification = adpPopup.getStorage('popup-age-' + (elData(popup, 'id') || 0))
				if (!ageVerification) adpPopup.openPopup(popup)
			}

			if ('delay' === trigger) {
				setTimeout(function () {
					adpPopup.openPopup(popup)
				}, elData(popup, 'open-delay-number') * 1000)
			}

			if ('exit' === trigger) {
				var showExit = true
				document.addEventListener('mousemove', function (e) {
					const scroll = window.pageYOffset || document.documentElement.scrollTop
					if (e.pageY - scroll < 7 && showExit) {
						adpPopup.openPopup(popup)
						showExit = false
					}
				})
			}

			if ('scroll' === trigger) {
				const pointScrollType = elData(popup, 'open-scroll-type')
				const pointScrollPosition = elData(popup, 'open-scroll-position')

				document.addEventListener('scroll', function () {
					if ('px' === pointScrollType && window.scrollY >= pointScrollPosition) {
						adpPopup.openPopup(popup)
					}
					if ('%' === pointScrollType && adpPopup.getScrollPercent() >= pointScrollPosition) {
						adpPopup.openPopup(popup)
					}
				})
			}

			if ('accept' === trigger) {
				const accept = adpPopup.getStorage('popup-accept-' + (elData(popup, 'id') || 0))
				if (!accept) adpPopup.openPopup(popup)
			}
		},

		closeTriggerPopup: function (popup) {
			const trigger = elData(popup, 'close-trigger')

			if ('delay' === trigger) {
				setTimeout(function () {
					adpPopup.closePopup(popup)
				}, elData(popup, 'close-delay-number') * 1000)
			}

			if ('scroll' === trigger) {
				const pointScrollType = elData(popup, 'close-scroll-type')
				const pointScrollPosition = elData(popup, 'close-scroll-position')
				const initScrollPx = elData(popup, 'init-scroll-px')
				const initScrollPercent = elData(popup, 'init-scroll-percent')

				document.addEventListener('scroll', function () {
					if ('px' === pointScrollType) {
						if (adpPopup.sDirection === 'up' && window.scrollY < initScrollPx - pointScrollPosition) {
							adpPopup.closePopup(popup)
						}
						if (adpPopup.sDirection === 'down' && window.scrollY >= initScrollPx + pointScrollPosition) {
							adpPopup.closePopup(popup)
						}
					}
					if ('%' === pointScrollType) {
						if (adpPopup.sDirection === 'up' && adpPopup.getScrollPercent() < initScrollPercent - pointScrollPosition) {
							adpPopup.closePopup(popup)
						}
						if (adpPopup.sDirection === 'down' && adpPopup.getScrollPercent() >= initScrollPercent + pointScrollPosition) {
							adpPopup.closePopup(popup)
						}
					}
				})
			}
		},

		openPopup: function (popup) {
			if (popup.classList.contains('popup-open')) return
			if (popup.classList.contains('popup-already-opened')) return

			if (popup.matches('[data-body-scroll-disable="true"]')) {
				document.body.classList.add('popup-scroll-hidden')
			}

			const id = elData(popup, 'id') || 0
			const limit = parseInt(adpPopup.getStorage('popup-' + id) || 0) + 1
			adpPopup.setStorage('popup-' + id, limit, { expires: elData(popup, 'limit-lifetime') })

			popup.classList.add('popup-open')

			elData(popup, 'init-scroll-px', window.scrollY)
			elData(popup, 'init-scroll-percent', adpPopup.getScrollPercent())

			const animation = elData(popup, 'open-animation')
			adpPopup.applyAnimation(popup, animation)

			adpPopup.closeTriggerPopup(popup)
		},

		agePopup: function (el) {
			const popup = el.closest('.popup')
			if (!popup) return
			adpPopup.setStorage('popup-age-' + (elData(popup, 'id') || 0), 1, { expires: 360 })
		},

		ageDeclined: function () {
			document.querySelectorAll('.age-verification__question').forEach(function (el) {
				el.classList.remove('show')
			})
			document.querySelectorAll('.age-verification__declined').forEach(function (el) {
				el.classList.add('show')
			})
		},

		acceptPopup: function (el) {
			const popup = el.closest('.popup')
			if (!popup) return
			adpPopup.setStorage('popup-accept-' + (elData(popup, 'id') || 0), 1, { expires: 360 })
		},

		closePopup: function (el) {
			const popup = el.closest ? el.closest('.popup') : document.querySelector(el)
			if (!popup) return

			const animation = elData(popup, 'exit-animation')
			adpPopup.applyAnimation(popup, animation, function () {
				popup.classList.add('popup-already-opened')
				popup.classList.remove('popup-open')
				document.body.classList.remove('popup-scroll-hidden')
			})
		},

		isAllowPopup: function (popup) {
			const limitDisplay = parseInt(elData(popup, 'limit-display') || 0)
			const limitDisplayCookie = parseInt(adpPopup.getStorage('popup-' + elData(popup, 'id')))

			if (limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay) {
				return
			}

			return true
		},

		applyAnimation: function (el, name, callback) {
			const popup = el.closest ? el.closest('.popup') : el
			if (!popup) return

			const overlayName = typeof callback === 'function' ? 'popupExitFade' : 'popupOpenFade'

			const overlay = popup.nextElementSibling
			if (overlay && overlay.classList.contains('popup-overlay')) {
				overlay.classList.add('popup-animated', overlayName)
				overlay.addEventListener('animationend', function () {
					overlay.classList.remove('popup-animated', overlayName)
				}, { once: true })
			}

			const wrap = popup.querySelector('.popup-wrap')
			if (wrap) {
				const classes = ['popup-animated']
				if (name) classes.push(name)
				wrap.classList.add(...classes)
				wrap.addEventListener('animationend', function () {
					wrap.classList.remove(...classes)
					if (typeof callback === 'function') callback()
				}, { once: true })
			}
		},

		getCookie: function (name) {
			const matches = document.cookie.match(
				new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
			)
			return matches ? decodeURIComponent(matches[1]) : undefined
		},

		getStorage: function (key) {
			const item = localStorage.getItem(key)
			if (item) {
				try {
					const parsed = JSON.parse(item)
					if (parsed.expires && Date.now() > parsed.expires) {
						localStorage.removeItem(key)
						return undefined
					}
					return parsed.value
				} catch {
					return undefined
				}
			}
			const cookieValue = adpPopup.getCookie(key)
			if (cookieValue !== undefined) {
				adpPopup.setStorage(key, cookieValue)
				return cookieValue
			}
			return undefined
		},

		setStorage: function (key, value, options = {}) {
			const data = { value, expires: null }
			if (options.expires) {
				const expiresDate = new Date()
				expiresDate.setDate(expiresDate.getDate() + parseInt(options.expires, 10))
				data.expires = expiresDate.getTime()
			}
			localStorage.setItem(key, JSON.stringify(data))
		},

		getScrollPercent: function () {
			const h = document.documentElement
			const b = document.body
			return ((h.scrollTop || b.scrollTop) / ((h.scrollHeight || b.scrollHeight) - h.clientHeight)) * 100
		},
	}

	adpPopup.init()

	document.addEventListener('shopify:section:load', function () {
		adpPopup.init()
	})

	document.addEventListener('shopify:section:unload', function () {
		document.body.classList.remove('popup-scroll-hidden')
	})
})()
